import adminApi from "./adminApiClient";

const adminAccountingApi = {
  async listJournalEntries(params) {
    const res = await adminApi.get("/api/accounting/journal-entries", { params });
    return res.data;
  },

  async getJournalEntry(id) {
    const res = await adminApi.get(`/api/accounting/journal-entries/${id}`);
    return res.data;
  },

  async getTrialBalance(params) {
    const res = await adminApi.get("/api/accounting/reports/trial-balance", { params });
    return res.data;
  },

  async getPnL(params) {
    const res = await adminApi.get("/api/accounting/reports/pnl", { params });
    return res.data;
  },

  async getTaxSummary(params) {
    const res = await adminApi.get("/api/accounting/reports/tax-summary", { params });
    return res.data;
  },
};

export default adminAccountingApi;
